module.exports = __webpack_public_path__ + "static/media/covid19-adolescent-top-banner.d0d57bab.png";